import SectionHeading from "./SectionHeading";

const genres = [
  {
    name: "科幻",
    desc: "太空史诗、时间旅行与近未来想象。",
    image: "https://readdy.ai/api/search-image?query=Stylized%20sci-fi%20genre%20concept%20art%20with%20a%20ringed%20planet%20and%20shuttle%20silhouette%20in%20deep%20space%2C%20warm%20amber%20nebula%20and%20crimson%20glow%2C%20cinematic%20illustration%2C%20elegant%20minimal&width=640&height=420&seq=genre-scifi-101&orientation=landscape",
  },
  {
    name: "动作",
    desc: "酣畅打斗与肾上腺素飙升的场面。",
    image: "https://readdy.ai/api/search-image?query=Dynamic%20action%20genre%20concept%20art%20with%20a%20silhouette%20leaping%20against%20an%20explosion%20of%20warm%20orange%20embers%20and%20dust%2C%20cinematic%20high%20contrast%2C%20dramatic%20motion%2C%20illustration&width=640&height=420&seq=genre-action-202&orientation=landscape",
  },
  {
    name: "剧情",
    desc: "直抵人心的人物与生活质感。",
    image: "https://readdy.ai/api/search-image?query=Emotional%20drama%20genre%20concept%20art%20of%20two%20figures%20in%20soft%20window%20light%20in%20a%20quiet%20room%2C%20warm%20sepia%20tones%2C%20intimate%20contemplative%20mood%2C%20cinematic%20illustration&width=640&height=420&seq=genre-drama-303&orientation=landscape",
  },
  {
    name: "悬疑",
    desc: "烧脑反转，谜底永远出人意料。",
    image: "https://readdy.ai/api/search-image?query=Intriguing%20mystery%20genre%20concept%20art%20with%20moody%20corridor%20lighting%20and%20silhouette%20holding%20a%20faint%20light%2C%20deep%20shadow%20and%20warm%20accent%20glow%2C%20noir%20cinematic%20illustration&width=640&height=420&seq=genre-mystery-404&orientation=landscape",
  },
  {
    name: "动画",
    desc: "想象力没有边界的美学乐园。",
    image: "https://readdy.ai/api/search-image?query=Whimsical%20animation%20genre%20concept%20art%20of%20colorful%20floating%20balloons%20and%20paper%20stars%20in%20a%20dreamy%20sky%2C%20warm%20pastel%20gold%20and%20cream%20tones%2C%20playful%20cinematic%20illustration&width=640&height=420&seq=genre-anime-505&orientation=landscape",
  },
  {
    name: "喜剧",
    desc: "把快乐打包，专治各种不开心。",
    image: "https://readdy.ai/api/search-image?query=Cheerful%20comedy%20genre%20concept%20art%20with%20confetti%20burst%20and%20a%20giant%20smile%20face%20balloon%2C%20bright%20warm%20orange%20and%20coral%20tones%2C%20joyful%20playful%20cinematic%20illustration&width=640&height=420&seq=genre-comedy-606&orientation=landscape",
  },
];

export default function GenreExplorer() {
  const pick = (name: string) => window.dispatchEvent(new CustomEvent("chigua-genre", { detail: name }));

  return (
    <section id="genre" className="section-pad scroll-mt-20 bg-background-100">
      <div className="container-x">
        <SectionHeading
          eyebrow="题材片库"
          title="按你的口味，探索海量片库"
          desc="不管你是科幻迷、推理控还是动画粉，选一个熟悉的题材，立刻跳转到该题材的精选片单。"
        />
        <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-3">
          {genres.map((g) => (
            <button
              key={g.name}
              type="button"
              onClick={() => pick(g.name)}
              className="group relative flex h-44 flex-col justify-end overflow-hidden rounded-2xl text-left md:h-52"
            >
              <img
                src={g.image}
                alt={g.name + " 电影题材"}
                className="absolute inset-0 h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-transparent"></div>
              <div className="relative p-5">
                <h3 className="font-heading text-lg font-black text-white md:text-xl">{g.name}</h3>
                <p className="mt-1 text-xs text-white/75 md:text-sm">{g.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 rounded-full bg-white/15 px-3 py-1 text-xs font-semibold text-white backdrop-blur-sm opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  去看片单
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}